import { atom } from "recoil";

export const stepperRegisterShowState = atom({
    key: 'stepperRegisterShow',
    default: false
});

export const stepperRecoveryPasswordShowState = atom({
    key: 'stepperRecoveryPasswordShow',
    default: false
});

export const stepperDeleteUserShowState = atom({
    key: 'stepperDeleteUserShow',
    default: false
});